import axios from "axios";
import Vue from "vue";

export const state = {
    campaigns: [],
    postsByCampaign: {}
};

export const getters = {
    hasCampaignsData(state) {
        return state.campaigns.length > 0;
    },
    activeCampaigns(state) {
        return state.campaigns.filter(campaign => {
            return campaign.tag === 'active';
        })
    },
};

export const mutations = {
    CLEAR(state) {
        state.campaigns = [];
    },
    SET_CAMPAIGNS(state, campaigns) {
        state.campaigns = campaigns
    },
    ADD_CAMPAIGN(state, campaign) {
        state.campaigns.push(campaign);
    },
    UPDATE_CAMPAIGN(state, campaign) {
        const campaignForUpdate = state.campaigns.find(c => c._id === campaign._id);
        if (campaignForUpdate) {
            Object.assign(campaignForUpdate, campaign)
        }
    },
    REMOVE_CAMPAIGN(state, campaign) {
        const indexForDelete = state.campaigns.findIndex(c => c._id === campaign._id);
        state.campaigns.splice(indexForDelete, 1);
    },
    SET_POSTS_TO_CAMPAIGN(state, {campaignId, posts}) {
        state.postsByCampaign[campaignId] = posts
    },
    MARK_AS_FINISHED(state, campaign) {
        const campaignForUpdate = state.campaigns.find(c => c._id === campaign._id);
        if (campaignForUpdate) {
            Vue.set(campaignForUpdate, 'tag', 'finished');
        }
    }
};

export const actions = {
    async getCampaignsData({ commit, rootGetters }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            let campaignsPath = '/client/campaign'
            if (rootGetters['user/userType'] === 'influencer') {
                campaignsPath = '/campaign'
            }

            let { data } = await axios.get(campaignsPath);

            commit('SET_CAMPAIGNS', data);
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
    async getCampaignPosts({ commit, rootGetters }, campaignId) {
        const userType = rootGetters['user/userType'];
        const response = await axios.get(`/${userType}/campaign/${campaignId}/posts`);

        const posts = response.data
        commit('SET_POSTS_TO_CAMPAIGN', {campaignId, posts})
    },
};
